import Schedule from "./schedule"

window.Schedule = Schedule;